<template>
  <div class="assembly-goods-control">
    <draggable :list="value" animation="100">
      <div
        class="add-goods-content"
        v-for="(sortItem, index) of value"
        :key="index"
      >
        <div
          class="title-box"
          :style="{ marginBottom: !value[index].sortName ? '10px' : '20px' }"
        >
          <p><span>*</span>分组名称</p>
          <el-input
            :value="value[index].sortName"
            @pointerdown.stop.native
            @input="val => sortNameInput(index, val)"
          ></el-input>
        </div>
        <p
          v-if="!value[index].sortName"
          style="font-size: 12px;color: red;padding-left: 64px;margin-bottom: 10px;"
        >
          请填写分组名称
        </p>
        <div class="goods-box">
          <draggable :list="sortItem.goods" animation="100" filter=".unDrag">
            <div
              v-for="(item, i) of sortItem.goods"
              class="goods-box-item"
              :key="item.id"
            >
              <div
                v-for="(it, j) of item.productList"
                :key="it.id"
                :style="{
                  marginRight: j + 1 === item.productList.length ? '0' : '4px'
                }"
              >
                <img :src="it.imageUrl" alt="" />
              </div>
              <i class="el-icon-error" @click="removeGoodItem(index, i)"></i>
            </div>

            <div
              v-if="sortItem.goods.length < 100"
              class="add-goods-btn unDrag"
              @click="addSortGoods(index)"
            >
              <i class="el-icon-plus"></i>
              <p class="add-text">选择搭销商品</p>
            </div>
          </draggable>
        </div>

        <i class="el-icon-error" @click="removeSortItem(index)"></i>
      </div>
    </draggable>
    <el-button icon="el-icon-plus" @click="addSort"
      >新增分组（{{ value.length }}/{{ maxLength }}）</el-button
    >

    <SelectAssemblyProductDialog
      :isShowDialog="isShowAssemblyDialog"
      :SelectedProductList="selectedGoods"
      @selectProductList="selectProductList"
      @closeShowDialog="isShowAssemblyDialog = false"
      :canMultipleChoice="true"
    />
  </div>
</template>

<script>
import draggable from "vuedraggable";
import SelectAssemblyProductDialog from "../../../../components/SelectAssemblyProductDialog";
export default {
  components: {
    draggable,
    SelectAssemblyProductDialog
  },
  props: {
    value: {
      type: Array,
      default: () => {
        return [];
      }
    },
    maxLength: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      selectedGoods: [],
      isShowAssemblyDialog: false,
      sortIndex: 0
    };
  },
  methods: {
    sortNameInput(index, val) {
      const params = this.value;
      params[index].sortName = val;
      this.$emit("input", params);
    },
    selectProductList(params) {
      this.value[this.sortIndex].goods = params;
    },
    addSortGoods(i) {
      this.sortIndex = i;
      this.selectedGoods = this.value[i].goods;
      this.isShowAssemblyDialog = true;
    },
    removeGoodItem(sortIndex, goodsIndex) {
      this.value[sortIndex].goods.splice(goodsIndex, 1);
    },
    removeSortItem(i) {
      this.value.splice(i, 1);
    },
    addSort() {
      if (this.value.length >= this.maxLength) {
        this.$message.warning(`最多添加${this.maxLength}个分组`);
        return;
      }

      const length = this.value.length + 1;
      const title = this.$convertToChineseNumber(length);
      const sortName = `分组${title}`;
      this.value.push({
        sortName,
        goods: []
      });
    }
  }
};
</script>
<style lang="less" scoped>
.assembly-goods-control {
  > div {
    > .add-goods-content {
      width: 332px;
      background: #f7f8fa;
      border-radius: 4px;
      padding: 14px 10px 0;
      margin-bottom: 10px;
      position: relative;
      cursor: move;
      > i {
        font-size: 16px;
        color: #bbbbbb;
        border-radius: 50%;
        background: #fff;
        position: absolute;
        top: -8px;
        right: -8px;
        cursor: pointer;
      }
      > .title-box {
        width: 100%;
        display: flex;
        align-items: center;
        > p {
          font-size: 12px;
          color: #333333;
          white-space: nowrap;
          margin-right: 10px;
          > span {
            color: #ff0000;
          }
        }
        /deep/ .el-input {
          flex: 1;
          .el-input__inner {
            padding: 0 10px;
            height: 30px;
            line-height: 30px;
            font-size: 12px;
            color: #333333;
            border: 1px solid #e5e5e5;
            &::placeholder {
              color: #999999;
            }
          }
        }
      }
      > .goods-box {
        > div {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          > .goods-box-item {
            height: 78px;
            position: relative;
            margin-bottom: 9px;
            cursor: move;
            display: flex;
            align-items: center;
            background: #e4e4e4;
            padding: 0 6px;
            border-radius: 4px;
            > div {
              > img {
                width: 66px;
                height: 66px;
                border-radius: 3px;
                display: block;
              }
            }
            > i {
              font-size: 16px;
              color: #bbbbbb;
              border-radius: 50%;
              background: #fff;
              position: absolute;
              top: -6px;
              right: -6px;
              cursor: pointer;
            }
          }
          > .add-goods-btn {
            width: 78px;
            height: 78px;
            background: #ffffff;
            border-radius: 4px;
            border: 1px solid #eeeeee;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin-bottom: 14px;
            cursor: pointer;
            margin-left: 6px;
            i {
              font-size: 14px;
              font-weight: bold;
              color: #2154f4;
              margin-bottom: 4px;
            }
            .add-text {
              font-size: 10px;
              font-weight: 400;
              color: #2154f4;
            }
          }
        }
      }
    }
  }
  /deep/ .el-button {
    width: 332px;
    height: 30px;
    background: #ffffff;
    border-radius: 2px;
    border: 1px solid #2154f4;
    color: #2154f4;
    font-size: 12px;
    padding: 0;
    margin-top: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/custom-component/productComponents/AssemblySortGoods/components/GoodsControl.vue